import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaInfoCircle, FaArrowLeft, FaArrowRight, FaCheckCircle } from 'react-icons/fa';

const TransactionFooter = ({
  step,
  totalSteps,
  loading,
  success,
  onPrev,
  onNext,
  onSubmit,
  onCancel,
  isStepValid
}) => {
  const getStepTitle = () => {
    switch (step) {
      case 1: return 'Sélection du type';
      case 2: return 'Détails de la transaction';
      case 3: return 'Documents justificatifs';
      default: return '';
    }
  };

  const getNextButtonLabel = () => {
    if (step < totalSteps) return 'Continuer';
    if (loading) return 'Traitement en cours...';
    if (success) return 'Transaction réussie !';
    return 'Valider la transaction';
  };

  return (
    <Modal.Footer className="border-top px-4 py-3">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div>
          <small className="text-muted d-block mb-1">
            Étape {step} sur {totalSteps}
          </small>
          <span className="fw-semibold">{getStepTitle()}</span>
        </div>
        
        <div className="d-flex align-items-center gap-2">
          {step > 1 && (
            <Button 
              variant="outline-secondary" 
              onClick={onPrev}
              className="d-flex align-items-center"
              disabled={loading || success}
            >
              <FaArrowLeft className="me-2" />
              Précédent
            </Button>
          )}
          
          {step < totalSteps ? (
            <Button 
              variant="primary" 
              onClick={onNext}
              disabled={!isStepValid || loading || success}
              className="d-flex align-items-center"
            >
              {getNextButtonLabel()}
              <FaArrowRight className="ms-2" />
            </Button>
          ) : (
            <Button 
              variant="success" 
              onClick={onSubmit}
              disabled={loading || success}
              className="d-flex align-items-center px-4"
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Traitement...
                </>
              ) : success ? (
                <>
                  <FaCheckCircle className="me-2" />
                  Succès !
                </>
              ) : (
                <>
                  <FaCheckCircle className="me-2" />
                  Valider la transaction
                </>
              )}
            </Button>
          )}
          
          <Button 
            variant="light" 
            onClick={onCancel}
            disabled={loading}
            className="ms-2"
          >
            {success ? 'Fermer' : 'Annuler'}
          </Button>
        </div>
      </div>
      
      {!isStepValid && step < totalSteps && (
        <div className="w-100 mt-2">
          <small className="text-warning d-flex align-items-center">
            <FaInfoCircle className="me-1" />
            Veuillez remplir tous les champs requis avant de continuer
          </small>
        </div>
      )}
    </Modal.Footer>
  );
};

export default TransactionFooter;